const statementTableDictES = {
  financial: "Financiero",
  extracredit: "Extracredit",
  wallet: "Billetera",
  walletStatement: "Extracto de billetera",
  extracoinStatement: "Extracto de Extracredit",
  extrabonusStatement: "Extracto Bonus Ads",
  bonusStatement: "Extracto de la renta diaria vitalicia",
  planNotAllowed: "Su suscripción actual no tiene acceso a esta función.",
  statementSubtitle: "Siga las operaciones realizadas en su billetera usando Extracredit.",
  showingFirstToLast: "Mostrando {first} a {last} de {totalRecords}",
  noOperationsRecords: "Aún no hay registros de operaciones.",
  date: "Fecha",
  from: "De",
  toFrom: "Hasta",
  check: "Ver",
  statement: "Extracto",
  description: "Descripción",
  inbound: "Crédito",
  outbound: "Débito",
  status: "Estado",
  dateTransaction: "Fecha de la transacción",
  emptyDates: "Por favor elija un periodo de dos fechas.",
  completed: "Completa",
  pending: "Pendiente",
  pendingVoucher: "Voucher pendiente",
  canceled: "Cancelada",
};

export default statementTableDictES;
